var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center align-center",attrs:{"fluid":"","id":"voucher_container"}},[(_vm.dataLoaded)?_c('voucherCard',{attrs:{"description":_vm.description,"beneficiary":_vm.organization.company,"instructions":_vm.instructions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }